import React, { ReactNode } from 'react';
import Text from 'components/components/Text';
import './DrawerTitle.scss';

export const getRequestTitle = (items: { service?: { name?: string } }[] = []) => (
  items.length === 1 ? items[0].service?.name || 'Request details' : 'Request details'
);

const DrawerTitleContent = ({ title, children }: { title: string, children?: ReactNode }) => (
  <div className="drawer-title">
    <Text text={title} size="l" />
    {children}
  </div>
);

DrawerTitleContent.defaultProps = { children: null };

export default DrawerTitleContent;
